import request from '@/config/axios'

export interface AiCsSkillGroupVO {
  id?: number
  sceneCode: string
  name: string
  deptId?: number
  /** 企微员工 userid，逗号分隔 */
  employeeUserIds?: string
  keywords?: string
  intentTags?: string
  priority?: number
  workStart?: string
  workEnd?: string
  offlineMsg?: string
  enabled: boolean
}

export interface AiCsTicketVO {
  id?: number
  sessionId?: number
  channel?: string
  channelConversationId?: string
  userId?: number
  shopId?: number
  skillGroupId?: number
  deptId?: number
  title: string
  content?: string
  status: string
  priority?: number
  source?: string
  assigneeId?: number
  createTime?: string
}

export const AiCsSkillGroupApi = {
  list: async (sceneCode?: string) => {
    return await request.get({ url: '/ai/cs/skill-group/list', params: { sceneCode } })
  },
  get: async (id: number) => {
    return await request.get({ url: '/ai/cs/skill-group/get', params: { id } })
  },
  create: async (data: AiCsSkillGroupVO) => {
    return await request.post({ url: '/ai/cs/skill-group/create', data })
  },
  update: async (data: AiCsSkillGroupVO) => {
    return await request.put({ url: '/ai/cs/skill-group/update', data })
  }
}

export const AiCsTicketApi = {
  page: async (params: any) => {
    return await request.get({ url: '/ai/cs/ticket/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/ai/cs/ticket/get', params: { id } })
  },
  updateStatus: async (data: { id: number; status: string; assigneeId?: number }) => {
    return await request.put({ url: '/ai/cs/ticket/update-status', data })
  },
  /** 座席回复客户（企微应用消息） */
  staffReply: async (data: { ticketId: number; content: string }) => {
    return await request.post({ url: '/ai/cs/ticket/staff-reply', data })
  }
}

export const AiCsKnowledgeCandidateApi = {
  page: async (params: any) => {
    return await request.get({ url: '/ai/cs/knowledge-candidate/page', params })
  },
  approve: async (id: number) => {
    return await request.put({ url: '/ai/cs/knowledge-candidate/approve', params: { id } })
  },
  reject: async (id: number) => {
    return await request.put({ url: '/ai/cs/knowledge-candidate/reject', params: { id } })
  }
}

export const AiCsSessionApi = {
  detail: async (sessionId: number) => {
    return await request.get({ url: '/ai/cs/session/detail', params: { sessionId } })
  }
}

export interface AiCsGrowthTaskVO {
  id?: number
  taskType: string
  title: string
  payloadJson?: string
  status?: string
  rateLimitPerHour?: number
  enabled?: boolean
  lastError?: string
  createTime?: string
}

export interface AiCsGrowthAuditVO {
  id?: number
  taskId: number
  action: string
  target?: string
  result?: string
  detail?: string
  createTime?: string
}

export const AiCsGrowthTaskApi = {
  page: async (params: any) => {
    return await request.get({ url: '/ai/cs/growth-task/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/ai/cs/growth-task/get', params: { id } })
  },
  create: async (data: AiCsGrowthTaskVO) => {
    return await request.post({ url: '/ai/cs/growth-task/create', data })
  },
  update: async (data: AiCsGrowthTaskVO) => {
    return await request.put({ url: '/ai/cs/growth-task/update', data })
  },
  start: async (id: number) => {
    return await request.put({ url: '/ai/cs/growth-task/start', params: { id } })
  },
  pause: async (id: number) => {
    return await request.put({ url: '/ai/cs/growth-task/pause', params: { id } })
  },
  tick: async () => {
    return await request.post({ url: '/ai/cs/growth-task/tick' })
  },
  auditPage: async (params: any) => {
    return await request.get({ url: '/ai/cs/growth-task/audit/page', params })
  },
  /** scene: moment=朋友圈附件；message=群发临时素材 */
  uploadMedia: async (type: 'image' | 'video' | 'file', file: File, scene: 'moment' | 'message' = 'message') => {
    const data = new FormData()
    data.append('type', type)
    data.append('scene', scene)
    data.append('file', file)
    return await request.upload<{ mediaId: string; type: string }>({
      url: '/ai/cs/growth-task/media/upload',
      data
    })
  }
}
